import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['hourInput', 'minuteInput', 'errorMessage', 'container']
  static values = {
    validationMessage: String
  };

  connect() {
    this._validateTimeInputs()
  }

  validateOnInput() {
    this._validateTimeInputs()
  }

  validateOnBlur() {
    this._validateTimeInputs()
  }

  // Called by form-errors controller during form validation
  validateForm() {
    this._validateTimeInputs()

    const allInputs = [...this.hourInputTargets, ...this.minuteInputTargets]
    return !allInputs.some(input => input.dataset.timeValidationError === 'true')
  }

  _validateTimeInputs() {
    const timePairs = this._getTimePairs()

    timePairs.forEach(pair => {
      this._validateTimePair(pair)
    })
  }

  _getTimePairs() {
    const pairs = []

    this.hourInputTargets.forEach((hourInput, index) => {
      if (this.minuteInputTargets[index]) {
        pairs.push({
          hourInput: hourInput,
          minuteInput: this.minuteInputTargets[index],
          errorMessage: this.errorMessageTargets[index],
          container: this.containerTargets[index]
        })
      }
    })

    return pairs
  }

  _validateTimePair(pair) {
    const { hourInput, minuteInput, errorMessage, container } = pair

    const hourValue = hourInput.value ? hourInput.value.trim() : ''
    const minuteValue = minuteInput.value ? minuteInput.value.trim() : ''

    const hourFilled = hourValue !== ''
    const minuteFilled = minuteValue !== ''

    // Invalid if only one is filled
    const isInvalid = (hourFilled && !minuteFilled) || (!hourFilled && minuteFilled)

    const hourContainer = hourInput.closest('.input-form')
    const minuteContainer = minuteInput.closest('.input-form')

    if (isInvalid) {
      // Hide the built-in NumberComponent error messages to avoid conflict
      const hourErrorContainer = hourContainer?.querySelector('.form-error')
      const minuteErrorContainer = minuteContainer?.querySelector('.form-error')

      if (hourErrorContainer) {
        hourErrorContainer.parentElement.parentElement.classList.remove('error:block')
      }
      if (minuteErrorContainer) {
        minuteErrorContainer.parentElement.parentElement.classList.remove('error:block')
      }

      if (container) container.classList.add('error')

      if (errorMessage) {
        const messageSpan = errorMessage.querySelector('.form-error')
        if (messageSpan) {
          messageSpan.textContent = this.validationMessageValue
        }
      }

      // Mark inputs as invalid without using setCustomValidity to avoid
      // triggering built-in errors
      hourInput.dataset.timeValidationError = 'true'
      minuteInput.dataset.timeValidationError = 'true'
    } else {
      delete hourInput.dataset.timeValidationError
      delete minuteInput.dataset.timeValidationError

      // Restore the built-in error containers
      const hourErrorContainer = hourContainer?.querySelector('.form-error')
      const minuteErrorContainer = minuteContainer?.querySelector('.form-error')

      if (hourErrorContainer) {
        hourErrorContainer.style.display = ''
      }

      if (minuteErrorContainer) {
        minuteErrorContainer.style.display = ''
      }

      // Hide our custom error message
      if (container) container.classList.remove('error')
    }
  }
}
